import FormStyleKeys from './FormStyleKeys';
const FormStyleKeysToGlobalMap = {
  [FormStyleKeys.LABEL_TEXT_COLOR]: 'fontColor',
  [FormStyleKeys.SUBMIT_FONT_COLOR]: 'buttonFontColor',
  [FormStyleKeys.SUBMIT_COLOR]: 'buttonBackgroundColor'
};
export default FormStyleKeysToGlobalMap;